import { useObrasCardsView } from "./use-obras-cards-view";
import { ObrasCardsViewView } from "./view-obras-cards-view";
import type { ObrasCardsViewProps } from "./types-obras-cards-view";

export function ObrasCardsView(props: ObrasCardsViewProps) {
  const vm = useObrasCardsView(props);

  return <ObrasCardsViewView {...vm} />;
}

export type * from "./types-obras-cards-view";
